export const constants = {
  api: "https://storageui.fly.dev/",
  // api: "http://localhost:8080/",
  networks: {
    ethereum: {
      display: "mainnet",
      network: "mainnet",
    },
    arbitrum: {
      display: "arbitrum one",
      network: "arbitrum",
    },
    polygon: {
      display: "polygon",
      network: "polygon",
    },
    optimism: {
      display: "optimism",
      network: "optimism",
    },
    avalanche: {
      display: "avalanche",
      network: "avalanche",
    },
    goerli: {
      display: "goerli",
      network: "goerli",
    },
    sepolia: {
      display: "sepolia",
      network: "sepolia",
    },
    polygon_testnet: {
      display: "polygon mumbai",
      network: "polygon_testnet",
    },
    arbitrum_testnet: {
      display: "arbitrum goerli",
      network: "arbitrum_testnet",
    },
    avalanche_testnet: {
      display: "avalanche fuji",
      network: "avalanche_testnet",
    },
  }
};
